<title>{{ pricingAndTicketingPage.htmlTitle }}</title>
<app-banner [banner]="pricingAndTicketingPage.banner"></app-banner>
<div class="container faq-disruption-notifications">
  <a [href]="BackLinkURL"><i [ngClass]="BackLinkIcon"></i>{{ BackLinkTitle }}</a>
  <app-border-section [param]="param" [sections]="pricingAndTicketingPage.sections"></app-border-section>
</div>
